import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["aria-selected", "data-testid", "onClick"]

import { computed, onMounted } from 'vue'

import { QUEUE_VIEW_OPTIONS } from './types'
import type { QueueViewMode, QueueViewOption } from './types'
import { readQueueViewPreference, writeQueueViewPreference } from './useQueueViewPreference'


export default /*#__PURE__*/_defineComponent({
  __name: 'QueueViewSwitcher',
  props: {
    modelValue: {},
    screenKey: {},
    options: { default: undefined },
    testId: { default: 'queue-view-switcher' },
    restorePreference: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const resolvedOptions = computed(() => props.options ?? QUEUE_VIEW_OPTIONS)

function select(value: QueueViewMode): void {
  writeQueueViewPreference(props.screenKey, value)
  emit('update:modelValue', value)
}

// A preferência é aplicada no mount, e não no `setup` do pai: quem abre a tela
// por um link com `?view=` já chega com a visão pedida, e só cai na preferência
// quando o pai não impôs nada diferente do padrão.
onMounted(() => {
  if (!props.restorePreference) return
  const preferred = readQueueViewPreference(props.screenKey, props.modelValue)
  if (preferred !== props.modelValue) emit('update:modelValue', preferred)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "tablist",
    "aria-label": "Visão",
    class: "inline-flex flex-wrap gap-1 rounded-lg bg-lightGray30 p-1",
    "data-testid": _ctx.testId
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedOptions.value, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.value,
        type: "button",
        role: "tab",
        "aria-selected": option.value === _ctx.modelValue,
        "data-testid": `${_ctx.testId}-${option.value}`,
        class: _normalizeClass(["rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors", 
        option.value === _ctx.modelValue
          ? 'bg-white text-textPrimary shadow-sm'
          : 'bg-transparent text-neutral50 hover:text-textPrimary'
      ]),
        onClick: ($event: any) => (select(option.value))
      }, _toDisplayString(option.label), 11, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

})